import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { generatePath, useHistory } from "react-router-dom";

import { LoadingButton } from "../../../components/LoadingButton";
import { type PlacementDetail } from "../../api/useGetPlacement";
import { PLACEMENT_PATHS } from "../../paths";
import { usePlacementDetailReferralViewCountStorage } from "../PlacementReferrals/usePlacementDetailReferralViewCount";
import { useSharePlacementReferral } from "../PlacementReferrals/useSharePlacementReferral";

const MAX_PLACEMENT_DETAILS_REFERRAL_VIEW_COUNT = 3;

interface PlacementDetailsReferralButtonProps {
  eventContext: Record<string, unknown>;
  highestRankingSharedQualification: string | undefined;
  placementDetails: PlacementDetail;
}

export function PlacementDetailsReferralButton(props: PlacementDetailsReferralButtonProps) {
  const { eventContext, highestRankingSharedQualification, placementDetails } = props;

  const { handleShareReferral, isLoadingReferralCode, maxReferralBonusAmount } =
    useSharePlacementReferral();

  const worker = useDefinedWorker();

  const history = useHistory();

  const { placementDetailsReferralViewCount } = usePlacementDetailReferralViewCountStorage();

  async function handleShareReferralCode() {
    if (placementDetailsReferralViewCount < MAX_PLACEMENT_DETAILS_REFERRAL_VIEW_COUNT) {
      logEvent(APP_V2_APP_EVENTS.PLACEMENT_REFER_JOB_REFERRAL_PAGE_REDIRECT, {
        ...eventContext,
        workerUserId: worker.userId,
      });

      history.push(
        generatePath(PLACEMENT_PATHS.PLACEMENT_REFERRAL_SHARE_LINK, {
          placementId: placementDetails.id,
        })
      );
      return;
    }

    await handleShareReferral({
      placementId: placementDetails.id,
      payRange: placementDetails.payRange,
      workplaceName: placementDetails.workplace.name,
      qualificationDisplayLabel:
        highestRankingSharedQualification ?? placementDetails.workerTypes?.[0] ?? "",
      // At the time of implementation, there are only 3 placements with null address.formatted
      formattedAddress: placementDetails.address.formatted ?? "",
      additionalContext: eventContext,
    });
  }

  return (
    <LoadingButton
      fullWidth
      isLoading={isLoadingReferralCode}
      startIconType="share"
      variant="outlined"
      onClick={async () => {
        await handleShareReferralCode();
      }}
    >
      Share job, earn ${maxReferralBonusAmount}
    </LoadingButton>
  );
}
